import React, { useEffect, useRef, useState } from "react";
import styles from "../signupastutor/style/tutorregister.module.css";
import tutorHero from "../../../assets/frontendpage/becometutorimage/tutor-signup-hero.png";
import Toast from "../../../utils/commoncomponent/Toast";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import { signupRequest } from "../../../redux/actions/signupAction";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import TermsLink from "../Terms/TermsLink";
import { COUNTRY_CODES } from "../../../utils/countryCodes";

const initialFormData = {
  userName: "",
  emailId: "",
  phoneNo: "",
  countryCode: "91",
  password: "",
  createdBy: "tutor",
  role: "tutor",
};

const Tutorregister = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [cpassword, setCpassword] = useState("");
  const [errors, setErrors] = useState({});
  const fullNameRef = useRef(null);
  const emailRef = useRef(null);
  const mobileNumberRef = useRef(null);
  const passwordRef = useRef(null);
  const cpasswordRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showCpassword, setShowCpassword] = useState(false);
  const [showPasswordTooltip, setShowPasswordTooltip] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const signupLoading = useSelector((state) => state.signup.loading);
  const signupDone = useSelector((state) => state.signup.success);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  useEffect(() => {
    if (signupDone) {
      navigate(`/emailverification?email=${encodeURIComponent(formData.emailId)}&role=${formData.role}`);
    }
  }, [signupDone, formData.emailId, formData.role, navigate]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleCpasswordVisibility = () => {
    setShowCpassword(!showCpassword);
  };

  const handlePasswordChange = (event) => {
    setCpassword(event.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const Validation = () => {
    let isValid = true;
    const updatedErrors = {};

    // Validate Full Name
    if (formData.userName.trim().length < 2) {
      isValid = false;
      updatedErrors.fullName = "Name should be at least 2 characters";
      fullNameRef.current.focus();
    } else if (/^[\s]/.test(formData.userName)) {
      isValid = false;
      updatedErrors.fullName = "Name should not start with a space";
      fullNameRef.current.focus();
    } else if (!/^[a-zA-Z\s]*$/.test(formData.userName)) {
      isValid = false;
      updatedErrors.fullName = "Only alphabets and spaces are allowed";
      fullNameRef.current.focus();
    }

    // Validate Email
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      isValid = false;
      updatedErrors.email = "Enter a valid email address";
      emailRef.current.focus();
    }

    // Password Validation
    const passwordPattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,20}$/;
    if (!passwordPattern.test(formData.password)) {
      isValid = false;
      updatedErrors.password = "Password must meet the criteria.";
      setShowPasswordTooltip(true);
      passwordRef.current.focus();
    }

    // Confirm Password Validation
    if (formData.password !== cpassword) {
      isValid = false;
      updatedErrors.confirmPassword = "Passwords do not match.";
      cpasswordRef.current.focus();
    }

    // Validate Mobile Number
    if (formData.phoneNo.length !== 10 || isNaN(formData.phoneNo)) {
      isValid = false;
      updatedErrors.mobileNumber = "Mobile number must be 10 digits long";
      mobileNumberRef.current.focus();
    }

    // Validate Checkbox
    const termsCheckbox = document.getElementById("termsCheckbox");
    if (!isTermsAccepted) {
      isValid = false;
      Toast.error("Please agree to the terms and conditions");
    }

    setErrors(updatedErrors);

    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = Validation();
    if (!isValid) {
      return;
    } else {
      dispatch(signupRequest(formData));
    }
  };

  return (
    <div className={`${styles.signupContainer} authPageShell`}>
      <div className="authOrb authOrb1" aria-hidden="true" />
      <div className="authOrb authOrb2" aria-hidden="true" />
      <div className={styles.signupUnifiedCard}>
        <div className={styles.signupLayout}>
          <div className={styles.signupDetails}>
            <span className={styles.signupBadge}>Join as Tutor</span>
            <h1>Create Your Account</h1>
            <p className={styles.signupLead}>
              Share your expertise and connect with students near you.
            </p>
            <form onSubmit={handleSubmit}>
            <input
              ref={fullNameRef}
              name="userName"
              type="text"
              placeholder="Enter the full name"
              value={formData.userName}
              onChange={handleChange}
              required
            />
            {errors.fullName && (
              <div
                className="error-message"
                style={{ color: "red", marginBottom: "15px" }}
              >
                {errors.fullName}
              </div>
            )}

            <input
              ref={emailRef}
              name="emailId"
              type="email"
              placeholder="Enter your Email"
              value={formData.emailId}
              onChange={handleChange}
              required
            />
            {errors.email && (
              <div
                className="error-message"
                style={{ color: "red", marginBottom: "15px" }}
              >
                {errors.email}
              </div>
            )}

            <div className={styles.selectWrapper}>
              <select
                id="country-code"
                name="countryCode"
                value={formData.countryCode}
                onChange={handleChange}
                required
              >
                {COUNTRY_CODES.map((country) => (
                  <option key={country.code} value={country.code}>
                    {country.label}
                  </option>
                ))}
              </select>
              <input
                ref={mobileNumberRef}
                name="phoneNo"
                type="number"
                placeholder="Enter your Mobile Number"
                value={formData.phoneNo}
                onChange={handleChange}
                required
              />
            </div>
            {errors.mobileNumber && (
              <div
                className="error-message"
                style={{ color: "red", marginBottom: "15px" }}
              >
                {errors.mobileNumber}
              </div>
            )}

            <div className={styles.passwordField}>
              <input
                ref={passwordRef}
                className={styles.passwordInput}
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                value={formData.password}
                onChange={handleChange}
                minLength={8}
                maxLength={20}
                onPaste={(e) => e.preventDefault()}
                onCopy={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                required
              />
              <span
                className="material-symbols-outlined eye-icon"
                onClick={togglePasswordVisibility}
                style={{ cursor: "pointer" }}
              >
                {showPassword ? "visibility_off" : "visibility"}
              </span>
            </div>
            {errors.password && (
              <div
                className="error-message"
                style={{ color: "red", marginBottom: "15px" }}
              >
                {errors.password}
                {showPasswordTooltip && (
                  <Tooltip title="Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character (!@_#).">
                    <IconButton aria-label="password criteria">
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            )}

            <div className={styles.passwordField}>
              <input
                ref={cpasswordRef}
                className={styles.passwordInput}
                name="cpassword"
                type={showCpassword ? "text" : "password"}
                placeholder="Re-enter Password"
                value={cpassword}
                onChange={handlePasswordChange}
                minLength={8}
                maxLength={20}
                onPaste={(e) => e.preventDefault()}
                onCopy={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                required
              />
              <span
                className="material-symbols-outlined eye-icon"
                onClick={toggleCpasswordVisibility}
                style={{ cursor: "pointer" }}
              >
                {showCpassword ? "visibility_off" : "visibility"}
              </span>
            </div>
            {errors.confirmPassword && (
              <div
                className="error-message"
                style={{ color: "red", marginBottom: "15px" }}
              >
                {errors.confirmPassword}
              </div>
            )}

            {/* Checkbox Section */}
            <div className={styles.signupTermsRow}>
              <input
                type="checkbox"
                id="termsAndConditions"
                checked={isTermsAccepted}
                onChange={(e) => setIsTermsAccepted(e.target.checked)}
                className={styles.signupTermsCheckbox}
              />
              <label
                htmlFor="termsAndConditions"
                className={styles.signupTermsLabel}
              >
                By Registering, you agree to our{" "}
                <TermsLink label="Terms of Use & Privacy Policy" />
              </label>
            </div>

            <button
              type="submit"
              className={`${styles.createButton} ${signupDone ? styles.createButtonDone : ""}`}
              disabled={!isTermsAccepted || signupLoading || signupDone}
            >
              {signupLoading ? (
                <span className={styles.buttonLoader}>
                  <span className={styles.spinner} />
                  Registering...
                </span>
              ) : signupDone ? (
                "✓ Registered! Check your email for OTP"
              ) : (
                "Register"
              )}
            </button>
          </form>
          <p className={styles.authSwitch}>
            Already have an account?{" "}
            <Link to="/login" className={styles.authSwitchLink}>
              Login
            </Link>
          </p>
        </div>
        <div className={styles.signupImageColumn}>
          <div className={styles.imageFloatWrap}>
            <img
              src={tutorHero}
              alt="Tutor guiding students in a group learning session"
              className={styles.signupImage}
            />
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Tutorregister;
